<template>
  <div class="app">
    <AppHeader fixed>
       <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard/">
        <img
          class="navbar-brand-full"
          src="img/brand/Alpha.jpg"
          width="100"
          height="45"
          alt="CoreUI Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/part.png"
          width="20"
          height="20"
          alt="Fiber Node Services"
        />
      </b-link>
       <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none" style="margin:auto;">

          <b-form-input
            style="display:inline-block; width:150px;margin-left:150px"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
          <b-form-select id="basicSelect"
            :plain="true"
            :options="[{text:'RA#', value:'ra'}, {text:'Invoice#', value:'inv'}, {text:'Serial', value:'serial'}]"
            placeholder="Please select"
            v-model="selected"
            textfield="text"
            valuefield="value">
          </b-form-select>
          <b-button
          :disabled="searchQuery ? false : true"
            @click="searchFor()"
          >Search </b-button>

      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <!--        <b-nav-item class="d-md-down-none">-->
        <!--          <i class="icon-bell"></i>-->
        <!--          <b-badge pill variant="danger">5</b-badge>-->
        <!--        </b-nav-item>-->
        <!--        <b-nav-item class="d-md-down-none">-->
        <!--          <i class="icon-list"></i>-->
        <!--        </b-nav-item>-->
        <!--        <b-nav-item class="d-md-down-none">-->
        <!--          <i class="icon-location-pin"></i>-->
        <!--        </b-nav-item>-->
        <!-- <b-nav-item class="d-md-down-none">
         <span class="mr-1">{{full_name}}</span>
        </b-nav-item> -->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!--      <AsideToggler class="d-none d-lg-block" />-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
       <AppSidebar>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav style="width: 230px" :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div style="padding-top: 17px" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <!--        <a href="https://www.fibernode.com/main/">Fiber Node Services Inc.</a>-->
        <!--        <span class="ml-1">&copy; 2020 </span>-->
      </div>
      <div class="ml-auto">
        <a href="https://www.fibernode.com/main/">Fiber Node Services Inc.</a>
        <span class="ml-1">&copy; 2020</span>
        <!--        <span class="mr-1">Powered by</span>-->
        <!--        <a href="https://coreui.io">CoreUI for Vue</a>-->
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import axi from 'axios';
export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      full_name: "",
      ip:"",
      selected: 'ra',
      searchQuery: null,
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  mounted() {
    this.full_name = localStorage.getItem("alpha_full_name");
  },
  methods:{
    searchFor() {
      this.$router.push('/search/?type=' + this.selected + '&value=' + this.searchQuery)
    },
    getUserData () {
      axi.get('https://www.cloudflare.com/cdn-cgi/trace')
          .then(res => {
            const ipRegex = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/
            const IP = res.data.match(ipRegex)[0];
            this.ip=IP;
            this.logData();
          })
    },
    logData() {
      let formData = new FormData();
      formData.append("portal", 'ALPHA');
      formData.append("ip", this.ip);
      formData.append("user", localStorage.getItem('alpha_user'));
      this.$http.post('api/logUser.php',formData)
          .then((response) => {
            console.log(response)
          }).catch(err => {
        console.log(err)
      })
    }},
  created() {
    this.getUserData();
  }
};
</script>

<style>
.sidebar .nav {
  width: 225px;
}
html:not([dir="rtl"]) .sidebar {
  margin-left: -225px;
}
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .sidebar-nav {
    overflow: visible;
    width: 50px !important;
  }
}
</style>
